<template>
  <div class="orderDetails" v-cloak>
    <div v-if="expressInfo.createTime" class="orderDetails-box f-webkit-box" v-touch:tap="goToLogistics">
      <div class="f-box-flex1 orderDetails-bg f-c">查看物流</div>
      <div class="f-box-flex1 f-info-r">
        <i class="iconfont f-color-CECECE">&#xe6ab;</i>
      </div>
    </div>
    <div class="orderDetails-box f-webkit-box">
      <div class="orderDetails-address">
        <i class="iconfont f-color-fff">&#xe635;</i>
      </div>
      <div class="f-box-flex1 f-p-l-sm">
        <div class="orderDetails-information">
          <div class="orderDetails-text f-w-60" style="margin-right:40px" v-if="detail.distribution">{{detail.distribution.recipients}}</div>
          <div class="orderDetails-text" v-if="detail.distribution">{{detail.distribution.mobilePhone}}</div>
        </div>
        <div class="orderDetails-text" v-if="detail.distribution">{{detail.distribution.detailAddress}}</div>
      </div>
    </div>
    <div class="orderDetails-box f-p-t-0">
      <div class="order-box" v-for="item in detail.ORDER_GOODS_DETAILS" :key="item.id">
        <div class="f-webkit-box order-box-top">
          <van-image :src="getImagePrefix + item.COVER_URL" radius="6" class="order-img" />
          <div class="f-box-flex1">
            <div class="order-title">{{item.NAME}}</div>
            <div class="order-norms">规格：{{item.SKU_NAM}}</div>
            <div class="order-price">
              <span>¥</span>
              {{item.PRICE}}
            </div>
          </div>
        </div>
        <div class="f-webkit-box f-p-t-md">
          <div class="f-box-flex1 order-btn">
            <!-- <van-button type="default" v-touch:tap="refunds(idtem.id)">申请退款</van-button> -->
          </div>
        </div>
      </div>
      <div class="orderDetails-message">
        <!-- <div class="message-text">优惠：¥{{preference}}</div>
        <div class="message-text">配送方式：{{mode}}</div>-->
        <div class="message-text">订单备注：{{detail.REMARK}}</div>
        <div class="message-text">订单总价：¥{{detail.ORDER_MONEY}}</div>
      </div>
      <div class="orderDetails-payment">
        实付金额：
        <span class="f-size-14 f-color-FF7613">¥</span>
        <span class="f-size-16 f-color-FF7613">{{detail.ORDER_MONEY}}</span>
      </div>
    </div>
    <div class="orderDetails-box">
      <div class="orderDetails-text">
        订单编号：
        <span class="f-color-666 f-color-12">{{detail.ORDER_ID}}</span>
      </div>
      <div class="orderDetails-text">
        下单时间：
        <span class="f-color-666 f-color-12">{{detail.ORDER_TIME}}</span>
      </div>
      <div class="orderDetails-text" v-if="expressInfo.createTime">
        发货时间：
        <span class="f-color-666 f-color-12">{{formatTime(expressInfo.createTime)}}</span>
      </div>
    </div>
    <div class="orderDetails-box f-webkit-box">
      <div class="f-box-flex1 order-condition">{{converCodeToText( detail.ORDER_STATE)}}</div>

      <div class="f-box-flex1 order-btn">
        <template v-if="detail.ORDER_STATE==101">
          <div class="btn" v-touch:tap.stop="cancelOrder(detail.ORDER_ID)">取消</div>
          <div class="btn">待支付</div>
        </template>

        <template v-else-if="detail.ORDER_STATE==401 || detail.ORDER_STATE===402">
          <div class="btn" v-touch:tap.stop="deleteOrder(detail.ORDER_ID)">删除</div>
        </template>
        <template v-else-if="detail.ORDER_STATE==201">
          <router-link
            class="btn"
            tag="div"
            :to="{name:'refunds',query:{orderId:detail.ORDER_ID}}"
          >申请退款</router-link>
          <!-- <div
            class="btn"
            v-touch:tap.stop.prevent="requestRefund(detail.ORDER_ID,detail.SELLERRES)"
          >申请退款</div>-->
        </template>
        <template v-else-if="detail.ORDER_STATE==205">
          <div class="btn">退款中</div>
          <!-- <router-linkg class="btn" tag="div" :to="{name:'HaiBoTangorderDetails'}">退款中</router-linkg> -->
        </template>
        <template v-else-if="detail.ORDER_STATE==405">
          <div class="btn" v-touch:tap.stop="deleteOrder(detail.ORDER_ID)">删除</div>
          <div class="btn" v-touch:tap.stop="orderRefundSuccessful(detail.ORDER_MONEY)">退款成功</div>
        </template>
        <template v-else-if="detail.ORDER_STATE==202">
          <div class="btn" v-touch:tap.stop="recieveConfirm(detail.ORDER_ID)">确认收货</div>
          <router-link
            class="btn"
            tag="div"
            :to="{name:'refunds',query:{orderId:detail.ORDER_ID}}"
          >申请退款</router-link>
          <!-- <div
            class="btn"
            v-touch:tap.stop.prevent="requestRefund(detail.ORDER_ID,detail.SELLERRES)"
          >申请退款</div>-->
        </template>
        <template v-else-if="detail.ORDER_STATE==303">
          <router-link
            class="btn"
            tag="div"
            :to="{name:'appraisals',query:{orderId:detail.ORDER_ID}}"
          >评价</router-link>
        </template>
        <template v-else-if="detail.ORDER_STATE==304 ">
          <!-- <van-button type="default">已评价</van-button> -->
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { Button } from "vant";
import http from "@js/http-hbt.js";
import util from "@util";
import {
  getUserOrderList,
  deleteOrder,
  cancelOrder,
  getOrderDetail,
  recieveConfirm,
  getExpressByOrderIdUrl,
} from "@js/shoppingUrl.js";

export default {
  components: {
    [Button.name]: Button
  },
  inject: ["reload"],

  data() {
    return {
      detail: {
        distribution: {
          recipients: ''
        },
      },
      expressInfo: {
        createTime: null
      },
    };
  },
  computed: {
    getImagePrefix() {
      return this.$store.state.shoppingBlock.bgImgPrefix || "";
    },
    userId() {
      return this.$store.state.userInfo.userId;
    },

  },
  methods: {
    converCodeToText(code) {
      let config = {
        101: "待支付",
        200: "待确认",
        201: "待发货",
        202: "待收货",
        203: "待发货",
        205: "退款中",
        301: "消费中",
        302: "已消费",
        303: "交易成功",
        304: "已评价",
        401: "已取消（商家）",
        402: "已取消（买家）",
        502: "异步下单成功",
        503: "分销退款中",
        504: "分销下单其他异常",
        502: "异步下单成功",
        503: "分销退款中",
        405: "已退款：",
        403: "已取消（管理员）",
        404: "已取消（系统）",
        405: "退款成功"
      };

      return config[code];
    },

    getDetail(orderId) {
      http.post(getOrderDetail, { orderId }).then(({ data }) => {
        this.detail = data;
      });
    },
    deleteOrder(orderId) {
      return () => {
        this.$dialog
          .confirm({
            message: "是否确认删除?"
          })
          .then(() => {
            http
              .post(deleteOrder, {
                userId: this.userId,
                orderId
              })
              .then(res => {
                this.$toastSuccessReload("已删除该订单", this.$gotoLastPage);
              });
          });
      };
    },
    $gotoLastPage() {
      this.$router.go(-1);
    },
    cancelOrder(orderId) {
      return () => {
        this.$dialog
          .confirm({
            message: "是否确认取消？"
          })
          .then(() => {
            http
              .post(cancelOrder, {
                orderId,
                userId: this.userId
              })
              .then(res => {
                this.$toastSuccessReload("已取消该订单", this.$gotoLastPage);
              });
          });
      };
    },
    recieveConfirm(orderId) {
      return () => {
        this.$dialog
          .confirm({
            message: "是否确认收货"
          })
          .then(() => {
            http
              .post(recieveConfirm, {
                orderId,
                userId: this.userId
              })
              .then(res => {
                this.$toastSuccessReload();
              });
          });
      };
    },
    $toastSuccessReload(
      message = "操作成功",
      onCloseCallback = () => {
        this.reload();
      }
    ) {
      let timer = setTimeout(() => {
        clearTimeout(timer);
        this.$toast({
          type: "success",
          message,
          onClose: onCloseCallback
        });
      }, 50);
    },
    orderRefundSuccessful(price) {
      return () => {
        this.$dialog.alert({
          message: `您的退款将在3-15个工作日内原路返回您的账户，退款总金额:￥${price}`
        });
      };
    },
    requestRefund(orderId, sellerres) {
      return () => {
        if (sellerres) {
          this.$dialog.alert({
            message: `申请失败，卖家已拒绝您的申请，${sellerres},请联系客服电话：0898-65238891`
          });
        } else {
          this.$router.push({
            name: "refunds",
            query: { orderId }
          });
        }
      };
    },
    goToLogistics(){
      if(this.detail.ORDER_ID){
        this.$router.push({
          name: "logistics",
          query: { id: this.detail.ORDER_ID }
        });
      }
    },
    getExpressByOrderId(orderId){
      http.post(getExpressByOrderIdUrl, { orderId })
        .then(res=>{
          if(res.data)this.expressInfo = res.data;
        })
    },
    formatTime(time = '') {
      return util.formatTime(new Date(time));
    },
  },
  created() {
    var {
      query: { orderId }
    } = this.$route;
    this.orderId = orderId;
    this.getDetail(this.orderId);
    this.getExpressByOrderId(this.orderId);
  }
};
</script>

<style lang="less" scoped>
.orderDetails {
  background-color: #eff0fa !important;
  padding: 10px 7px;

  .btn {
    display: inline-block;
    border-radius: 11px;
    border: 1px solid rgba(213, 213, 213, 1);
    width: 72px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    color: #666666;
    font-size: 12px;
    margin: 0 5px;
  }
  .orderDetails-box {
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    margin-bottom: 10px;
    padding: 15px 10px;
    .orderDetails-text {
      color: #343434;
      font-size: 12px;
      line-height: 18px;
    }
    .f-color-CECECE {
      color: #cecece;
    }
    .f-color-000 {
      color: #000;
    }
    .f-info-r {
      text-align: right;
    }
    .f-p-l-sm {
      padding-left: 10px;
    }
    .orderDetails-address {
      width: 33px;
      height: 33px;
      background: linear-gradient(
        162deg,
        rgba(255, 163, 0, 1) 0%,
        rgba(255, 126, 154, 1) 100%
      );
      border-radius: 50%;
      line-height: 33px;
      text-align: center;
      .f-color-fff {
        color: #fff;
      }
    }
    .orderDetails-bg {
      background: url(../../lib/image/personalCenter/wuliu.png) left center
        no-repeat;
      background-size: 15px 12px;
      padding-left: 20px;
      color: #343434;
      font-size: 12px;
      display: flex;
      align-items: center;
    }
    .orderDetails-information {
      padding-bottom: 10px;
      div {
        display: inline-block;
      }
      .f-w-60 {
        width: 60px;
      }
    }
    .orderDetails-message {
      border-bottom: 1px solid #e7e7e7;
      padding-top: 12px;
      .message-text {
        font-size: 12px;
        color: #666666;
        line-height: 16px;
        padding-bottom: 12px;
      }
    }
    .orderDetails-payment {
      padding-top: 15px;
      text-align: right;
      color: #797979;
      font-size: 12px;
      .f-size-16 {
        font-size: 16px;
      }
      .f-size-14 {
        font-size: 14px;
      }
      .f-color-FF7613 {
        color: #ff7613;
        font-weight: 500;
      }
    }
    .f-color-666 {
      color: #666;
    }
    .f-color-12 {
      font-size: 12px;
    }
    .order-condition {
      color: #ff7613;
      line-height: 22px;
      font-weight: 500;
      font-size: 12px;
    }
    .order-btn {
      text-align: right;
    }
    .order-box {
      background: rgba(255, 255, 255, 1);
      padding: 18px 0;
      border-bottom: 1px solid #e7e7e7;
      .order-box-top {
        // padding-bottom: 10px;
        .order-img {
          width: 86px;
          height: 84px;
          margin-right: 10px;
        }
        .order-title {
          color: #1a1b1d;
          font-size: 12px;
          line-height: 18px;
        }
        .order-norms {
          color: #1a1b1d;
          font-size: 12px;
          line-height: 18px;
          padding: 6px 0;
        }
        .order-price {
          color: #ff7613;
          font-size: 18px;
          font-weight: 500;
          line-height: 20px;
          text-align: left;
          span {
            font-size: 14px;
          }
        }
      }
      .order-condition {
        color: #ff7613;
        line-height: 22px;
        font-weight: 500;
        font-size: 12px;
      }
      .order-btn {
        text-align: right;
      }
    }
  }
  .f-p-t-0 {
    padding-top: 0;
  }
  .f-box-flex1 {
    overflow: hidden;
    box-flex: 1;
    -webkit-box-flex: 1;
    -moz-box-flex: 1;
    flex: 1;
    -webkit-flex: 1;
  }
  .f-webkit-box {
    display: -webkit-flex;
    display: -webkit-box;
    display: -moz-flex;
    display: -moz-box;
    display: -ms-flex;
    display: -ms-box;
    // display: box;
    display: flex;
  }
}
</style>